import React from 'react'
import Logger from '#src/services/logger'
import Redirect from '#src/components/Redirect'
import { Notification } from '@deal/components'
import { getSellableUrl } from '#src/services/sellable'
import { invariant } from '#src/services/errors'
import { SellableType, TrackableSellableFragment } from '#src/generated/graphql'

interface SellableRouterProps {
  sellable: TrackableSellableFragment
  requestedType: SellableType
}

const SellableRouter: React.SFC<SellableRouterProps> = ({ sellable, requestedType, children }) => {
  /**
   * A self-referncing default variant is 'unsellable'
   */
  if (!sellable.variant && sellable.variationMatrix) {
    if (sellable.variationMatrix.defaultVariant.id === sellable.id) {
      return invariant(`The sellable "${sellable.id}" has a self-referencing default variant`)
    }

    /**
     * If this is a variant and a sellable has a variation matrix, redirect to the default variant
     */
    return <Redirect to={getSellableUrl(sellable.variationMatrix.defaultVariant)} />
  }

  /**
   * Make sure the sellable type matches the requested type, this will handle if an
   * experiences sellable is on a products route and vice versa
   */
  if (sellable.type !== requestedType) {
    return <Redirect to={getSellableUrl(sellable)} />
  }

  if (children) {
    return <>{children}</>
  } else {
    Logger.captureException('Sellable router invoked without children')

    return (
      <Notification type="error">
        There was an error loading this product, please try again.
      </Notification>
    )
  }
}

export default SellableRouter
